import { nanoid } from "nanoid";
function uniqueId() {
  return nanoid();
}
export {
  uniqueId
};
//# sourceMappingURL=uniqueId.mjs.map
